import './style.css'
import { useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { EffectComposer, Bloom, ChromaticAberration, Vignette } from '@react-three/postprocessing'
import Experience from './Experience.jsx'
import LoadingScreen from './LoadingScreen.jsx'
import { Analytics } from "@vercel/analytics/react"

function App() {
    const [isLoading, setIsLoading] = useState(true)
    const [mobileIframeFullscreen, setMobileIframeFullscreen] = useState(false)

    const handleLoadingComplete = () => {
        // Start transition immediately - Canvas should be ready
        setTimeout(() => {
            setIsLoading(false)
        }, 200)
    }

    return (
        <>
            <Canvas
                className="r3f"
                style={{ 
                    opacity: isLoading ? 0 : 1,
                    transition: 'opacity 0.8s ease-in-out'
                }}
                camera={ {
                    fov: 45,
                    near: 0.1,
                    far: 2000,
                    position: [ -3, 1.5, 4 ]
                } }
            >
                <Experience 
                    loadingComplete={!isLoading} 
                    onMobileZoomIn={() => setMobileIframeFullscreen(true)}
                    mobileIframeFullscreen={mobileIframeFullscreen}
                />
                <EffectComposer>
                    <Bloom 
                        luminanceThreshold={0.2} 
                        luminanceSmoothing={0.9} 
                        height={300}
                        intensity={0.5}
                    />
                    <Vignette eskil={false} offset={0.1} darkness={0.8} />
                    <ChromaticAberration offset={[0.0005, 0.0012]} />
                </EffectComposer>
            </Canvas>

            {mobileIframeFullscreen && (
                <div className="mobile-fullscreen-overlay">
                    <button 
                        className="mobile-fullscreen-back-btn"
                        onClick={() => setMobileIframeFullscreen(false)}
                    >
                        ← Back to 3D View
                    </button>
                    <iframe 
                        src='https://3d-portfolio-three-opal.vercel.app/' 
                        className="mobile-fullscreen-iframe"
                    />
                </div>
            )}

            {isLoading && (
                <LoadingScreen onLoadingComplete={handleLoadingComplete} />
            )}

            <Analytics/>
        </>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)